// @ts-nocheck
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {createTransactionService} from "../../services/wallet/transaction.service";

const useCreateTransfer = () => {
  const query = useQueryClient();
  const {mutate, isSuccess, isError, error, isPending} = useMutation({
    mutationFn: createTransactionService,
    onSuccess: _data => {
      query.invalidateQueries(["userWallet"]);
    },
    onError: _error => {},
  });

  return {
    requestSendMoney: mutate,
    isSuccess,
    isError,
    error,
    isPending,
  };
};

export default useCreateTransfer;
